import { useState, useEffect, useCallback } from "react";
import { Grid, Button, Typography, Box } from "@mui/material";
import { socket } from "../config/network";
import { listenToAnswer } from "../services/InteractiveAnswerService";
import { winner, logo, image1, image2, image3, image4 } from "../Assets";

const questions = [
  {
    question:
      "When was Orange Egypt officially launched under the orange brand?",
    answers: ["2014", "2015", "2016", "2017"],
    correct: 3,
  },
  {
    question: "Which of the following is the current Orange Egypt slogan?",
    answers: [
      "Ma3ak w bnsma3ak",
      "Dayman Ma3ak",
      "bn’rabak ll gambak",
      "Orange btarablak",
    ],
    correct: 2,
  },
  {
    question: "What is the Speed of 5G in Egypt",
    answers: ["350", "250", "400", "200"],
    correct: 3,
  },
  {
    question: "In which year did Orange Egypt launch 4G services?",
    answers: ["2015", "2016", "2017", "2018"],
    correct: 3,
  },
  {
    question: "Which of the following is the correct 5G logo?",
    image: true,
    answers: [image1, image2, image3, image4],
    correct: 1,
  },
  {
    question: 'What does the "G" in 2G, 3G, 4G, and 5G stand for?',
    answers: ["Gigabyte", "Generation", "Google", "Grid"],
    correct: 2,
  },
  {
    question: "How much time it takes to download full movies with 5G?",
    answers: ["20 sec", "2 min", "4 min", "30 sec"],
    correct: 2,
  },
  {
    question: "SMS was introduced with which mobile generation?",
    answers: ["1G", "2G", "3G", "4G"],
    correct: 2,
  },
  {
    question: "What does LTE stand for?",
    answers: [
      "Light Transfer Engine",
      "Long-Term Evolution",
      "Live Telecom Exchange",
      "Low Traffic Entity",
    ],
    correct: 2,
  },
  {
    question: "In what year was the 2G network introduced globally?",
    answers: ["1985", "1991", "1999", "2002"],
    correct: 2,
  },
  {
    question: "In what year was 3G technology first introduced in Egypt?",
    answers: ["2002", "2005", "2007", "2010"],
    correct: 3,
  },
];

export default function QuizPage() {
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const handleClick = useCallback(
    (answerIndex) => {
      console.log("Answer clicked: ", answerIndex);

      const correctIndex = questions[current].correct;
      if (answerIndex === correctIndex) {
        setScore((prev) => prev + 1);
      }
      const next = current + 1;
      console.log(next, questions.length, "2wew");

      if (next < questions.length) {
        setCurrent(next);
      } else {
        setCurrent(next);

        setFinished(true);
      }
    },
    [current]
  );
  useEffect(() => {
    socket.auth = {
      token: localStorage.getItem("token"),
    };
    socket.disconnect().connect();
  }, []);

  useEffect(() => {
    listenToAnswer((data) => {
      const res = JSON.parse(data);
      const answer = Number(res?.answer);
      console.log("Answer: ", res?.answer);
      if (current + 1 <= questions.length) {
        answer > 0 && answer < 5 && handleClick(answer);
      } else {
        resetQuiz();
      }
    });
    return () => {
      socket.off("webhook_test_uuid");
    };
  }, [handleClick]);

  const resetQuiz = () => {
    setCurrent(0);
    setScore(0);
    setFinished(false);
  };

  if (finished) {
    const won = score === questions.length;
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor="white"
        sx={{ px: 2 }}
      >
        <Box
          textAlign="center"
          color="black"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: "100%",
          }}
        >
          <img src={logo} alt="logo" style={{ width: 120 }} />
          {!won && (
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              {"😢 Hard Luck"}
            </Typography>
          )}
          {won && <img src={winner} alt="result" style={{ width: 400 }} />}
          <Button
            onClick={resetQuiz}
            fullWidth
            variant="outlined"
            sx={{
              fontSize: 20,
              fontWeight: "bold",
              color: "black",
              borderColor: "black",
            }}
          >
            Try Again
          </Button>
        </Box>
      </Grid>
    );
  }

  const q = questions[current];

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="white"
      color="black"
      sx={{ px: 2 }}
      spacing={1}
    >
      <Grid item md={12} xs={12} fontWeight="bold" textAlign="center">
        <img src={logo} alt="logo" style={{ width: 180 }} />
      </Grid>
       <Grid item md={12} xs={12}></Grid>
      <Grid item md={6} xs={12}>
        <Typography
          fontSize={40}
          fontWeight="bold"
          textAlign="center"
          gutterBottom
        >
          {q.question}
        </Typography>
      </Grid>
      <Grid container  spacing={2} md={12} xs={12}>
        {q.answers.map((answer, index) => (
          <Grid item md={6} xs={6} key={index}>
            {q.image ? (
              <Button
                onClick={() => handleClick(index + 1)}
                fullWidth
                variant="outlined"
                sx={{
                  fontSize: 25,
                  fontWeight: "bold",
                  color: "black",
                  borderColor: "black",
                }}
              >
                <img
                  src={answer}
                  alt={answer}
                  style={{ width: 150, height: 120 }}
                />
              </Button>
            ) : (
              <Button
                onClick={() => handleClick(index + 1)}
                fullWidth
                variant="outlined"
                sx={{
                  fontSize: 25,
                  fontWeight: "bold",
                  color: "black",
                  borderColor: "black",
                  height: 120,
                }}
              >
                {answer}
              </Button>
            )}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
